import { call, put, select } from 'redux-saga/effects';

import getUsers from './getUsers';

import { callAPI, METHODS } from '../../api';
import { setBannerAPIRequestState } from '../../../effects/message';
import { RESOURCES } from '../../../../helpers/constants';

export default function* inviteUser({ payload }) {
  const organizationId = yield select((state) => state.organization.uuid);

  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${dpaApiBaseUrl}${RESOURCES.V3}/organizations/${organizationId}/users/${payload.userID}`;
  try {
    const { success, error } = yield call(callAPI, {
      url,
      method: METHODS.DELETE,
    });

    if (success && !error) {
      yield put(
        setBannerAPIRequestState({
          bannerState: 'success',
          bannerMessage: `${payload.email} has successfully been deleted`,
        }),
      );
      yield call(getUsers);
    } else {
      console.error(error);
      yield put(
        setBannerAPIRequestState({
          bannerState: 'error',
          bannerMessage: `We could not delete ${payload.email} at this time`,
        }),
      );
      yield call(getUsers);
    }
  } catch (e) {
    console.error(e);
    yield call(getUsers);
  }
}
